import { render, staticRenderFns } from "./DataGroupDefinitionForm.vue?vue&type=template&id=badd2e3a"
import script from "./DataGroupDefinitionForm.vue?vue&type=script&lang=js"
export * from "./DataGroupDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./DataGroupDefinitionForm.vue?vue&type=style&index=0&id=badd2e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports